export const selfIntroduction = `Hi, I'm Ng Kwan Ho, Alvin, a Computer Science graduate from the City University of Hong Kong.
                    I work as an Analyst Programmer, with experience in designing, building, and deploying systems to provide effective solutions.
                    My passion lies in creating user-friendly systems that simplify processes and deliver value to users.
                    Delivering intuitive and straightforward solutions is always my ultimate goal.`;

export const gitHubUrl = `https://github.com/adorablecatdev`;

export const profileCartDetails = [
    {
        image: `/image/SystemDevelopment.png`,
        header1: `System Development`,
        header2: `Focus on understanding requirements, designing user-friendly interfaces, creating clear system diagrams, and delivering well-documented specifications to ensure successful system development`,
        tools: [`Figma`, `Photoshop`, `Visual Paradigm`],
    },
    {
        image: `/image/FrontEndDevelopment.png`,
        header1: `Front-end Development`,
        header2: `Strive to build clean, responsive, and user-friendly interfaces that prioritize simplicity and a seamless experience for users.`,
        tools: [`React`, `Vue.js`, `jQuery`, `Angular`, `HTML`, `CSS`, `Bootstrap`, `Tailwind`],
    },
    {
        image: `/image/BackEndDevelopment.png`,
        header1: `Back-end Development`,
        header2: `Aim to develop reliable and efficient server-side applications, paying close attention to scalability, security, and integration with databases.`,
        tools: [`Node.js`, `Express js`, `next.js`, `MySQL`, `SQLServer`, `Spring-boot`, `PHP`, `JAVA`, `Docker`, `Nginx`, `IIS`],
    },
]